if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      show(opener) {
        super.show(opener);
        this.buildCarousel(opener);
      }

      buildCarousel(opener) {
        const dialog = this.querySelector('[role="document"]');
        if (!dialog) return;

        this.querySelectorAll('[data-media-id]').forEach((el) => {
          el.style.display = 'none';
        });

        // Collect all product images
        const allOpeners = Array.from(document.querySelectorAll('.product__modal-opener--image'));
        const images = [];
        const seen = new Set();
        allOpeners.forEach((el) => {
          const img = el.querySelector('img');
          if (img) {
            let src = img.src;
            if (img.srcset) {
              const srcsetParts = img.srcset.split(',').map(s => s.trim().split(' '));
              const largest = srcsetParts.reduce((a, b) => {
                return (parseInt(b[1]) || 0) > (parseInt(a[1]) || 0) ? b : a;
              });
              if (largest[0]) src = largest[0];
            }
            src = src.split('?')[0];
            if (!seen.has(src)) {
              seen.add(src);
              images.push({ src, alt: img.alt || '', el });
            }
          }
        });

        if (images.length === 0) return;

        // Preload ALL images immediately
        images.forEach((imgData) => {
          const preload = new Image();
          preload.src = imgData.src;
          imgData.preloaded = preload;
        });

        // Find clicked index by matching the opener element directly
        let currentIndex = 0;
        const clickedOpener = opener.closest('.product__modal-opener--image') || opener;
        const matchedIdx = images.findIndex(img => img.el === clickedOpener || img.el.contains(opener));
        if (matchedIdx !== -1) {
          currentIndex = matchedIdx;
        } else {
          // Fallback: match by src with size suffix normalization
          const clickedImg = opener.querySelector('img') || opener.closest('[data-media-id]')?.querySelector('img');
          if (clickedImg) {
            const normalize = src => src.split('?')[0].replace(/_([\d]+x[\d]*|[\d]*x[\d]+)\./g, '.');
            const clickedSrc = normalize(clickedImg.src);
            images.forEach((img, i) => {
              if (normalize(img.src) === clickedSrc) currentIndex = i;
            });
          }
        }

        // Remove old carousel
        document.querySelectorAll('.custom-carousel-wrap, .custom-carousel-prev, .custom-carousel-next, .custom-carousel-dots').forEach(el => el.remove());

        // Fullscreen overlay
        const wrap = document.createElement('div');
        wrap.className = 'custom-carousel-wrap';
        wrap.style.cssText = `
          position: fixed;
          top: 0; left: 0;
          width: 100vw; height: 100vh;
          background: rgba(0,0,0,0.92);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
        `;

        const imgEl = document.createElement('img');
        imgEl.src = images[currentIndex].src;
        imgEl.alt = images[currentIndex].alt;
        imgEl.style.cssText = `
          max-width: 85vw;
          max-height: 85vh;
          object-fit: contain;
          display: block;
          border-radius: 6px;
        `;

        const arrowBtnStyle = (side) => `
          position: fixed;
          ${side}: 20px;
          top: 50%;
          transform: translateY(-50%);
          background: rgba(255,255,255,0.15);
          backdrop-filter: blur(6px);
          color: white;
          border: 1.5px solid rgba(255,255,255,0.3);
          width: 48px; height: 48px;
          border-radius: 50%;
          cursor: pointer;
          z-index: 10000;
          display: ${images.length > 1 ? 'flex' : 'none'};
          align-items: center;
          justify-content: center;
          transition: background 0.2s;
        `;

        const prev = document.createElement('button');
        prev.className = 'custom-carousel-prev';
        prev.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>`;
        prev.style.cssText = arrowBtnStyle('left');
        prev.onmouseover = () => prev.style.background = 'rgba(255,255,255,0.3)';
        prev.onmouseout = () => prev.style.background = 'rgba(255,255,255,0.15)';

        const next = document.createElement('button');
        next.className = 'custom-carousel-next';
        next.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>`;
        next.style.cssText = arrowBtnStyle('right');
        next.onmouseover = () => next.style.background = 'rgba(255,255,255,0.3)';
        next.onmouseout = () => next.style.background = 'rgba(255,255,255,0.15)';

        const dots = document.createElement('div');
        dots.className = 'custom-carousel-dots';
        dots.style.cssText = `
          position: fixed;
          bottom: 24px;
          left: 50%;
          transform: translateX(-50%);
          display: flex;
          gap: 8px;
          z-index: 10000;
        `;

        const updateImage = (index) => {
          currentIndex = (index + images.length) % images.length;
          imgEl.src = images[currentIndex].preloaded.src;
          imgEl.alt = images[currentIndex].alt;
          dots.querySelectorAll('span').forEach((d, i) => {
            d.style.background = i === currentIndex ? 'white' : 'rgba(255,255,255,0.35)';
            d.style.transform = i === currentIndex ? 'scale(1.3)' : 'scale(1)';
          });
        };

        if (images.length > 1) {
          images.forEach((_, i) => {
            const dot = document.createElement('span');
            dot.style.cssText = `
              width: 9px; height: 9px;
              border-radius: 50%;
              background: ${i === currentIndex ? 'white' : 'rgba(255,255,255,0.35)'};
              cursor: pointer;
              display: inline-block;
              transition: all 0.2s;
              transform: ${i === currentIndex ? 'scale(1.3)' : 'scale(1)'};
            `;
            dot.addEventListener('click', () => updateImage(i));
            dots.appendChild(dot);
          });
        }

        prev.addEventListener('click', (e) => { e.stopPropagation(); updateImage(currentIndex - 1); });
        next.addEventListener('click', (e) => { e.stopPropagation(); updateImage(currentIndex + 1); });

        this._keyHandler = (e) => {
          if (e.key === 'ArrowLeft') updateImage(currentIndex - 1);
          if (e.key === 'ArrowRight') updateImage(currentIndex + 1);
          if (e.key === 'Escape') this.hide();
        };
        document.addEventListener('keydown', this._keyHandler);

        wrap.addEventListener('click', (e) => {
          if (e.target === wrap) this.hide();
        });

        wrap.appendChild(imgEl);
        document.body.appendChild(prev);
        document.body.appendChild(next);
        document.body.appendChild(dots);
        document.body.appendChild(wrap);

        this._cleanup = () => {
          document.querySelectorAll('.custom-carousel-wrap, .custom-carousel-prev, .custom-carousel-next, .custom-carousel-dots').forEach(el => el.remove());
          document.removeEventListener('keydown', this._keyHandler);
        };
      }

      hide() {
        if (this._cleanup) { this._cleanup(); this._cleanup = null; }
        super.hide();
      }
    }
  );
}
